import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["weight", "reps"]
  static values = {
    url: String,
    refWeight: String,
    refReps: String
  }

  toggle() {
    let weight = this.hasWeightTarget ? this.weightTarget.value.trim() : ""
    let reps = this.hasRepsTarget ? this.repsTarget.value.trim() : ""

    // Detect if unchecking (set already completed)
    const toggleButton = this.element.querySelector('[data-action="click->set-completion#toggle"]')
    const isUnchecking = toggleButton && toggleButton.classList.contains("bg-green")

    if (!isUnchecking) {
      // Fallback to reference values if inputs are empty
      if (!weight && this.refWeightValue) weight = this.refWeightValue
      if (!reps && this.refRepsValue) reps = this.refRepsValue

      // Validate: reps is always required, weight only if the input exists
      const missingFields = []
      if (!weight && this.hasWeightTarget) missingFields.push(this.weightTarget)
      if (!reps && this.hasRepsTarget) missingFields.push(this.repsTarget)

      if (missingFields.length > 0) {
        missingFields.forEach(field => {
          field.classList.add("!border-red", "!ring-1", "!ring-red")
          field.setAttribute("placeholder", "Preencha")
          field.addEventListener("input", () => {
            field.classList.remove("!border-red", "!ring-1", "!ring-red")
          }, { once: true })
        })
        return
      }
    }

    // Capture card reference before fetch (element may be replaced by Turbo)
    const card = this.element.closest('[data-controller~="rest-timer"]')
    const app = this.application

    const params = new URLSearchParams()
    params.append("weight", weight)
    params.append("reps", reps)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: params
    })
      .then(response => {
        if (response.ok) return response.text()
        throw new Error("Toggle failed")
      })
      .then(html => {
        Turbo.renderStreamMessage(html)

        // Start rest timer when completing a set (not when unchecking)
        if (!isUnchecking && card) {
          requestAnimationFrame(() => {
            // Only if card wasn't fully replaced (auto-complete replaces the whole card)
            if (document.body.contains(card)) {
              const timerController = app.getControllerForElementAndIdentifier(card, "rest-timer")
              if (timerController) {
                timerController.start()
              }
            }
          })
        }
      })
      .catch(error => console.error("Error toggling set:", error))
  }
}
